import React, { useEffect } from 'react'
import { makeStyles } from '@mui/styles'
import { isMeinBuero } from '@/utils/build-env'

import TopBar from './top-bar/top-bar'
import NavBar from './nav-bar/nav-bar'
import EmailConfirmationBar from './email-confirmation-bar/email-confirmation-bar'
import { useEmailConfirmationBar } from '@/hooks/useEmailConfirmationPending'
import { EmailConfirmationBarHeight, HEADER_HEIGHT_CSS_VAR, MenuHeight } from '@/themes/base'
import useWebSocketEvent, { EventTypes } from '@/modules/webSocket'
import { updateSubscriptionDetails } from '@/redux/ducks/subscription/details'
import { fetchData as fetchTenantData, refreshToken } from '@/redux/ducks/tenant/info'
import { fetchData as fetchTenantSetting } from '@/redux/ducks/tenant/settings'
import { fetchData as fetchUserData } from '@/redux/ducks/user/info'
import ThemeInterface from '@/theme-interface'
import { useAppDispatch } from '@/redux/store'

const menuId = isMeinBuero() ? 'menuMeinBuero' : 'menuOrgamax'
const useStyles = makeStyles((theme: ThemeInterface) => ({
  root: ({ withEmailConfirmationBar }: { withEmailConfirmationBar: boolean }) => ({
    display: 'grid',
    gridTemplateAreas: withEmailConfirmationBar ? '"doibar" "topbar" "navbar"' : '"topbar" "navbar"',
    gridTemplateRows: withEmailConfirmationBar ? `${EmailConfirmationBarHeight}px 40px 50px` : '40px 50px',
    width: '100vw',
    height: '100%',
    zIndex: 1000,
    position: 'relative',

    [theme.devices.mobile]: {
      display: 'none',
    },
  }),
}))

const MenuV2 = () => {
  const withEmailConfirmationBar = useEmailConfirmationBar()
  const classes = useStyles({ withEmailConfirmationBar })
  const dispatch = useAppDispatch()

  // DO-13065: the sass layout (`.layout-nav` grid rows, `.page` min-height, `.demoHeader` offset) reads
  // `var(--header-height, 90px)`; publish the grown height only while the bar is actually rendered.
  useEffect(() => {
    if (!withEmailConfirmationBar) return undefined
    const root = document.documentElement
    root.style.setProperty(HEADER_HEIGHT_CSS_VAR, `${MenuHeight + EmailConfirmationBarHeight}px`)
    return () => { root.style.removeProperty(HEADER_HEIGHT_CSS_VAR) }
  }, [withEmailConfirmationBar])

  useWebSocketEvent([EventTypes.TENANT_INFO_REFRESH, EventTypes.USER_INFO_REFRESH], msg => {
    if (msg.type === EventTypes.TENANT_INFO_REFRESH) {
      updateSubscriptionDetails(true, true)
      dispatch(fetchTenantData())
      dispatch(fetchTenantSetting())
    }
    if (msg.type === EventTypes.USER_INFO_REFRESH) {
      dispatch(fetchUserData())
    }
  })

  useWebSocketEvent(EventTypes.TOKEN_REFRESH, () => {
    dispatch(refreshToken(() => {
      updateSubscriptionDetails(true, true)
      dispatch(fetchTenantData())
      dispatch(fetchTenantSetting())
    }))
  })

  return (
    <div id={menuId} className={classes.root}>
      {withEmailConfirmationBar && <EmailConfirmationBar />}
      <TopBar />
      <NavBar />
    </div>
  )
}

export default MenuV2
